import { FLITCH_APPROVAL_FAILED, FLITCH_APPROVAL_REQUEST, FLITCH_APPROVAL_SUCCESS } from "app/redux/Approval/FlitchApproval/constant";

const INIT_STATE = {
    loading: false,
    totalPage: 0,
    data: [],
    error: {
        isError: false,
        message: null
    }
};

export const flitchApprovalReducer = function (state = INIT_STATE, action) {
    switch (action?.type) {
        case FLITCH_APPROVAL_REQUEST:
            return {
                loading: true,
                totalPage: 0,
                data: [],
                error: {
                    isError: false,
                    message: null
                }
            }
        case FLITCH_APPROVAL_SUCCESS:
            return {
                loading: false,
                data: action?.payload?.data,
                totalPage: action?.payload?.totalPage,
                error: {
                    isError: false,
                    message: null
                }
            }
        case FLITCH_APPROVAL_FAILED:
            const { isError = true, message = "Something Went Wrong" } = action?.payload?.error || {}
            return {
                loading: false,
                totalPage: 0,
                data: [],
                error: {
                    isError: isError,
                    message: message
                }
            }
        default:
            return state;
    }
};